import { render, staticRenderFns } from "./DanhSachVaiTro.vue?vue&type=template&id=4ec7dd10&"
import script from "./DanhSachVaiTro.vue?vue&type=script&lang=js&"
export * from "./DanhSachVaiTro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports